import { useQuery } from '@tanstack/react-query';
import { BudgetExpenseOrIncome } from 'business/constants';
import { InscriptionHistory } from 'routes/BudgetModule/components/BudgetOverview/AllInscriptions/types';
import { RQAPICallWithData } from 'store/APIClient';

const useGetInscriptionsHistory = (
    exercice: number,
    budgetName: string,
    enabled: boolean,
    expenseOrIncome: BudgetExpenseOrIncome,
) => {
    return useQuery({
        queryKey: ['history', exercice, budgetName],
        queryFn: async () => {
            const response = await RQAPICallWithData<InscriptionHistory[]>({
                endpoint: `budget/inscription/history/${budgetName}/${exercice}/${expenseOrIncome}`,
            });
            return response.content.data;
            // TODO: Error case to handle
        },
        meta: { useGlobalOnError: true },
        enabled,
    });
};

export default useGetInscriptionsHistory;
